import { shareColumnsExtend, shareFormColumnsExtend } from './share';
import _ from 'lodash';

const entityColumns = {
  id: {
    model_name: 'PaymentReminder',
    column_type: 'id',
  },
  created_at: {
    model_name: 'PaymentReminder',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'PaymentReminder',
    column_type: 'datetime',
  },
  sales_order: {
    model_name: 'PaymentReminder',
    column_type: 'belongs_to',
    extra: {
      association_name: 'sales_order',
      model_name: 'SalesOrder',
    },
  },
  sales_order_id: {
    model_name: 'PaymentReminder',
    column_type: 'belongs_to',
    extra: {
      association_name: 'sales_order',
      model_name: 'SalesOrder',
    },
  },
  stage_index: {
    model_name: 'PaymentReminder',
    column_type: 'integer',
  },
  percentage: {
    model_name: 'PaymentReminder',
    column_type: 'integer',
  },
  amount: {
    model_name: 'PaymentReminder',
    column_type: 'decimal',
  },
  date: {
    model_name: 'PaymentReminder',
    column_type: 'date',
  },
  state: {
    model_name: 'PaymentReminder',
    column_type: 'enum',
  },
  days_until_due: {
    model_name: 'PaymentReminder',
    column_type: 'string',
  },
  last_notified_at: {
    model_name: 'PaymentReminder',
    column_type: 'datetime',
  },
  can_receive: {
    model_name: 'PaymentReminder',
    column_type: 'string',
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(_.cloneDeep(entityColumns), columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(_.cloneDeep(entityColumns), columns, { formColumnsConfig, type, data })
}
